import React from "react";
import Login from "./components/Login/Login";
import { getUserCredential } from "./redux/reducers/LocalUserReducer";
import { useTypedSelector } from "./redux/reducers/RootReducer";
import Main from "./Main";
import useLicenseValidation from "./components/Hooks/useLicenseValidation";
import License from "./components/Login/License";
import Wait from "./Wait";

function Auth() {
  const { isLicenseValid, isLoading, isError } = useLicenseValidation();
  const user = useTypedSelector((state) => getUserCredential(state));

  if (isLicenseValid === undefined) return <Wait message="Loading Configuration" />;
  if (isLicenseValid === false) return <License isLoading={isLoading} isError={isError} />;
  if (user) return <Main />;
  return <Login />;
}

export default Auth;
